// Import SASS
import '../sass/style.scss'
// import '../sass/woocommerce.scss'

// Node_modules
import objectFitImages from 'object-fit-images'
import openPhotoSwipe from './modules/photoswipe-custom'
import AOS from 'aos'

// Import scripts
import '../partials/components/navigation/navigation'
import './modules/skip-link-focus-fix'
import shrinky from './modules/shrinky'

import search from '../partials/components/search/search-bar'

import { initSlider, initSmallSlider, initContentSlider } from '../partials/components/sliders/sliders'
import { initBlockSlider } from '../partials/components/blocks/block/block-slider'
import { initArticlesSlider } from '../partials/articles/articles-slider'
import { initProjectsSlider } from '../partials/components/projects/projects-slider'
import { initProductsSlider } from '../partials/components/products/products-slider'
import { initCategoriesSlider } from '../partials/components/categories/categories-slider'

// Object-fit fix
objectFitImages()

// Animate on scroll
AOS.init()

let currentData = [];
currentData = search('.search-bar-desktop', currentData);
currentData = search('.search-bar-mobile', currentData);

shrinky('.header', 150) // shrink header on scroll

openPhotoSwipe('.photoswipe')

// Init slider
let slider = initSlider('slider') // Value of [data-slider] attribute
// console.log('Just initialised the slider:', slider)

// Init slider
let smallSlider = initSmallSlider('small-slider') // Value of [data-slider] attribute
// console.log('Just initialised the slider:', smallSlider)

// Init slider
let contentSlider = initContentSlider('content-slider') // Value of [data-slider] attribute
// console.log('Just initialised the slider:', contentSlider)

// Init slider
let blockSliders = document.querySelectorAll('.block-slider') 

blockSliders.forEach((parent) => {
	// console.log(parent);
	let blockSlider = initBlockSlider('block-slider', parent) // Value of [data-slider] attribute
	// console.log('Just initialised the slider:', blockSlider)
})

// Init slider
let articlesSlider = initArticlesSlider('articles-slider') // Value of [data-slider] attribute
// console.log('Just initialised the slider:', articlesSlider)

// Init slider
let projectsSlider = initProjectsSlider('projects-slider') // Value of [data-slider] attribute
// console.log('Just initialised the slider:', projectsSlider)

// Init slider
let productsSlider = initProductsSlider('products-slider') // Value of [data-slider] attribute
// console.log('Just initialised the slider:', productsSlider)

// Init slider
let categorySliders = document.querySelectorAll('.categories-slider') 

categorySliders.forEach((parent) => {
	// console.log(parent);
	let categoriesSlider = initCategoriesSlider('categories-slider', parent) // Value of [data-slider] attribute
	console.log('Just initialised the slider:', categoriesSlider)
})